import React, { useState, useRef } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Input,
  Spinner
} from "reactstrap";
import Select2 from "react-select2-wrapper";
import "select2/dist/css/select2.min.css";
import { useTranslation } from "context/TranslationProvider";
import helpers from "utils/helpers";

const ExportModal = ({ isOpen, toggle, onExport, loading }) => {
  const { t } = useTranslation();
  const modalBodyRef = useRef(null);

  const [format, setFormat] = useState("csv");
  const [period, setPeriod] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");

  const handleDownload = () => {
    onExport({
      format,
      period: period || undefined,
      fromDate: !period ? fromDate : undefined,
      toDate: !period ? toDate : undefined,
    });
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered>
      <ModalHeader toggle={toggle} className="border">
        {t("modal.exportModal.title", "Export Logs")}
      </ModalHeader>

      <ModalBody ref={modalBodyRef} className="text-center">

        <p className="mb-3">
          {t("modal.exportModal.description", "Choose your preferred export format and time period.")}
        </p>

        <div className="d-flex justify-content-center gap-3 mb-4">
          <Button
            color={format === "csv" && "primary"}
            outline={format !== "csv"}
            onClick={() => setFormat("csv")}
            className="border"
          >
            {t("modal.exportModal.csv", "CSV")}
          </Button>

          <Button
            color={format === "excel" && "primary"}
            outline={format !== "excel"}
            onClick={() => setFormat("excel")}
            className="border"
          >
            {t("modal.exportModal.excel", "Excel")}
          </Button>
        </div>

        <div className="mb-3">
          <Select2
            className="form-control"
            value={period}
            onChange={(e) => setPeriod(e.target.value)}
            options={{
              width: "100%",
              dropdownParent: modalBodyRef.current,
              data: helpers.getExportPeriodOptions(t),
            }}
          />
        </div>

        {!period && (
          <div className="d-flex flex-column flex-sm-row justify-content-center gap-2 px-4 px-sm-0">
            <Input
              type="date"
              value={fromDate}
              onChange={(e) => setFromDate(e.target.value)}
              className="mb-2 mb-sm-0"
            />

            <Input
              type="date"
              value={toDate}
              onChange={(e) => setToDate(e.target.value)}
            />
          </div>
        )}
      </ModalBody>

      <ModalFooter className="border">
        <Button color="secondary" onClick={toggle}>
          {t("modal.exportModal.cancel", "Cancel")}
        </Button>

        <Button color="primary" onClick={handleDownload} disabled={loading}>
          {loading && <Spinner size="sm" className="mr-2" />}
          {t("modal.exportModal.download", "Download")}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default ExportModal;
